// Dependencies
const anime = require("animejs");
const flubber = require("flubber");
const Team = require("./components/Team");

window.addEventListener("DOMContentLoaded", () => {

    const paths = [
        "M494.4 130.32c-26.86 27.35-55.32 21.83-92.35 13.59s-82.65-19.2-143.85-2.72c-40.21 10.83-68.79 30.36-84.6 56.73s-18.85 59.55-7.99 97.69c10.93 38.35 30.94 63.39 57.09 78.06 26.16 14.67 58.46 18.97 93.97 15.87 82.56-7.22 125.63-28.76 160.45-51.14s61.39-45.59 110.93-56.16c54.59-11.64 91.33-34.75 108.56-62.63s14.93-60.54-8.56-91.27c-15.35-20.08-44.22-39.49-79.02-43.92-34.78-4.46-75.52 6.08-114.63 45.9z", "M494.4,130.32c-26.86,27.35-55.32,21.83-92.35,13.59S316.2,117.52,255,134  c-40.21,10.83-65.59,37.54-81.4,63.9s-29.85,70.55-18.99,108.69c10.93,38.35,30.94,63.39,57.09,78.06  c26.16,14.67,58.46,18.97,93.97,15.87C388.23,393.3,449.18,388.38,484,366c48-34,59.46-69.44,109-80c54.59-11.64,93.77-29.11,111-57  s23.56-75.96,0.07-106.69c-15.35-20.08-44.22-39.49-79.02-43.92C590.25,73.96,533.51,90.5,494.4,130.32z"
    ];

    let path = document.querySelector("#team #morphing-shape");
    let interpolator = flubber.interpolate(paths[0], paths[1]);
    let progress = { interpolation: 0 };

    anime({
        targets: progress,
        interpolation: 10000,
        easing: "easeInOutQuad",
        duration: 20000,
        loop: true,
        round: 10,
        direction: "alternate",
        update: () => path.setAttribute("d", interpolator(progress.interpolation / 10000))
    });

});

window.addEventListener("DOMContentLoaded", () => {

    document.querySelectorAll("[data-member]").forEach(element => new Team(element));

});


